import React from "react";
import { component_tool, utils_tool } from '@/tool';
let { WizModal, WizSurveyAudience, WizTypography, WizRow } = component_tool;
let { $$, checkStrLength } = utils_tool;


//配置项
let componentName = 'tableField'

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "字段英文名",
    name: "fieldCode",
    dataIndex: "fieldCode",
    searchItem: {},
    formItem: {
      maxlength: 64,
      placeholder: '字段英文名不能超过64个字符',
      rules: [
        {
          required: true,
          message: '请输入字段英文名'
        }
      ],
    },
    tableItem: {}
  },
  {
    title: "字段中文名",
    name: "fieldName",
    dataIndex: "fieldName",
    searchItem: {},
    formItem: {
      maxlength: 64,
      placeholder: '字段中文名不能超过64个字符',
      rules: [
        {
          required: true,
          message: '请输入字段中文名'
        }
      ],
    },
    tableItem: {}
  },
  {
    title: "是否为关联字段",
    name: "fieldRelation",
    dataIndex: "fieldRelation",
    tableItem: {},
    dict: [
      { code: 0, codeName: "否" },
      { code: 1, codeName: "是" }
    ],
    searchItem: {
      type: "select"
    },
    formItem: {
      type: 'select',
      rules: [{
        required: true,
        message: '请选择是否为关联字段',
      }],
      initialValue: 1
    }
  },
  {
    title: "搜索名称",
    name: "searchName",
    dataIndex: "searchName",
    searchItem: {},
    formItem: {
      maxlength: 64,
      placeholder: '搜索名称不能超过64个字符',
      rules: [
        {
          required: true,
          message: '请输入搜索名称'
        }
      ],
    },
    tableItem: {}
  },
  {
    title: "搜索类型",
    name: "fieldType",
    dataIndex: "fieldType",
    tableItem: {},
    searchItem: {
      type: "select"
    },
    dict: [
      { code: 0, codeName: "文本" },
      { code: 1, codeName: "数字" },
      { code: 2, codeName: "时间" },
      { code: 3, codeName: "枚举下拉框" },
      { code: 4, codeName: "自定义插件" }
    ],
    formItem: {
      type: 'select',
      rules: [{
        required: true,
        message: '请选择搜索类型',
      }],
      initialValue: 0
    }
  },
  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    tableItem: {},
    dict: [
      { code: 0, codeName: "无效" },
      { code: 1, codeName: "有效" }
    ],
    searchItem: {
      type: "select"
    },
    formItem: {
      type: 'select',
      rules: [{
        required: true,
        message: '请选择状态',
      }],
      initialValue: 1
    }
  }
];

const templateConfig  = (data) => {
  const {tableConfigId,_this} = data;
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        // paging: false,
        columns,
        searchBarProps: {
          collapse:false,
          buttonSort: ['add'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: {icon: 'plus', children: '新增', type: 'primary'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: `/dataReport/tableConfig/tableField/add`,
                  record: {tableConfigId}
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false,
        },
        rowOperateSort: ['update','enableOrDisable'],
        rowOperateView: [
          {
            key: "update",
            custom: true,
            params: { children: "编辑"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/dataReport/tableConfig/tableField/upd"
              }
            }
          },
          {
            key: "enableOrDisable",
            custom: true,
            params: { children: "启用"},
            textFormat: {
              recordKey: 'state',
              dirt: { 1: '禁用', 0: "启用" }
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "updateTableFieldState",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['state'] === 0 ? "启用" : "禁用"
                }该字段吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      state: record['state'] === 1 ? 0 : 1,
                      id: record['id']
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          }
        ],
        commonOperate: {
        },
      }
    }
  }
} ;




let reduxTemplateCofig = (args) => {
  const {tableConfigId} = args;
  const apis = {
    list: {
      path: `${componentName}/getAllListByPage`,
      payload: {
        key: `${componentName}@getAllListByPage`,
        apiParams: { pageNum: 1, pageSize: 10 ,tableConfigId}
      }
    },
    add: {
      path: `${componentName}/add`,
      payload: {
        key: `${componentName}@add`,
        apiParams: {}
      }
    },
    update: {
      path: `${componentName}/update`,
      payload: {
        key: `${componentName}@update`,
        apiParams: {}
      }
    },
    updateTableFieldState: {
      path: `${componentName}/updateTableFieldState`,
      payload: {
        key: `${componentName}@updateTableFieldState`,
        apiParams: {}
      }
    }
  }
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: false,
    keepInitApiParams: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
